<template>
  <div id="SellingListGM">
    <div class="blue">
      <div id="top">
        <div class="top1">
          <div id="Frabank_title">Turnover</div>
          <div class="turnover">€ {{ numberFilter(turnover.total) }}</div>
        </div>
        <div class="roundInfo">
          <div>
            {{ turnover.offer.count }} offer @
            {{ numberFilter(turnover.offer.price) }}€
          </div>
          <div>
            {{ turnover.approved.count }} approved @
            {{ numberFilter(turnover.approved.price) }}€
          </div>
          <div>
            {{ turnover.sold.count }} sold @
            {{ numberFilter(turnover.sold.price) }}€
          </div>
        </div>
      </div>
      <div id="middle">
        <div>
          <p>Barq #</p>
          <input class="sellerInput" maxlength="3" v-model="whichVerkaufId" @keyup="getPriceForBarq" />
        </div>
        <div class="preis white">{{ numberFilter(salesValue) }}€</div>
        <div class="white">{{ percentages[percentage_selected] }}%</div>
        <label class="check">
          Shp
          <input @change="changeAdjustedValue" type="checkbox" v-model="cert2" />
          <span class="checkmark"></span>
        </label>
        <label class="check">
          Sup
          <input @change="changeAdjustedValue" type="checkbox" v-model="cert3" />
          <span class="checkmark"></span>
        </label>
      </div>
      <div id="bottom">
        <div class="percentSelect">
          <div v-for="(p, i) in percentages" :key="p" @click="selectPercent(i)">
            {{ p }}%
          </div>
        </div>
        <button class="submit pointer" @click="sellerSubmit">submit</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SellingList",
  components: {},
  props: {
    // totalRevenue: {
    //   type: Number,
    //   default: () => 0,
    // },
    // sellingPrice: {
    //   type: Object,
    //   default: () => {},
    // },
    gamePhase: {
      type: Object,
      default: () => { },
    },
    sellingList: {
      type: Object,
      default: () => { },
    },
    token: {
      type: String,
      default: () => "",
    },
  },
  emits: ["setMessage"],
  watch: {
    gamePhase: function (newVal) {
      this.calcGamePhase(newVal);
    },
    sellingList: function (newVal) {
      this.calcTurnover(newVal);
    },
  },
  data() {
    return {
      cert2: false,
      cert3: false,
      salesValue: 0, //final sale value, send this
      verkaufspreis: 0,
      whichVerkauf: "",
      turnover: {
        total: 0,
        approved: {
          count: 0,
          price: 0,
        },
        offer: {
          count: 0,
          price: 0,
        },
        sold: {
          count: 0,
          price: 0,
        },
      },
      percentage_selected: 7, //=0
      percentages: [
        50, 20, 15, 10, 7.5, 5, 2.5, 0, -2.5, -5, -7.5, -15, -20, -30, -50,
      ],
      use_sellingList: {},
      whichVerkaufId: "",
    };
  },

  methods: {
    isSampleBarq(name) {
      var liste = [
        "BUB#001",
        "MAZ#002",
        "CUB#003",
        "GRD#004",
        "MOS#005",
        "MAN#006",
        "MOS#007",
        "MAZ#008",
        "MAN#009",
        "CUB#010",
        "BUB#011",
        "GRD#012",
      ];
      if (liste.includes(name)) {
        return true;
      }
      return false;
    },
    getPriceForBarq() {
      // console.log(this.whichVerkaufId);
      let id = this.whichVerkaufId;
      if (id.length <= 2) return;
      if (!this.use_sellingList[id]) {
        this.verkaufspreis = -1;
        this.salesValue = -1;
        return;
      }
      this.salesValue = this.use_sellingList[id].price;
      this.verkaufspreis = this.use_sellingList[id].price;
    },
    calcGamePhase(newVal) {
      if (!newVal) return;
      if (newVal.phase == 0) {
        //sample
        this.use_sellingList = {};
        for (const sell in this.sellingList) {
          // console.log(sell);
          if (this.isSampleBarq(sell)) {
            this.use_sellingList[sell.split("#")[1]] = this.sellingList[sell];
          }
        }
      } else if (newVal.phase == 1) {
        //round 1
        this.use_sellingList = {};
        let i = 0;
        for (const s of Object.keys(this.sellingList)) {
          if (!this.isSampleBarq(s)) {
            this.use_sellingList[s.split("#")[1]] = this.sellingList[s];
            if (i == 23) break;
            i++;
          }
        }
      } else {
        for (const sell in this.sellingList) {
          // round 2
          if (!this.isSampleBarq(sell)) {
            this.use_sellingList[sell.split("#")[1]] = this.sellingList[sell];
          }
        }
      }
    },
    calcTurnover(use_sellingList) {
      this.turnover = {
        total: 0,
        approved: {
          count: 0,
          price: 0,
        },
        offer: {
          count: 0,
          price: 0,
        },
        sold: {
          count: 0,
          price: 0,
        },
      };
      for (const s in use_sellingList) {
        if (use_sellingList[s].status == "non" || use_sellingList[s].status == "hacked") continue;
        if (use_sellingList[s].status && use_sellingList[s].price) {
          this.turnover[use_sellingList[s].status].count++;
          this.turnover[use_sellingList[s].status].price +=
            use_sellingList[s].price;

          if (use_sellingList[s].status == "sold") {
            this.turnover.total += use_sellingList[s].price;
          }
        }
      }
    },
    selectPercent(i) {
      this.percentage_selected = i;
      this.changeAdjustedValue();
      // this.salesValue = this.verkaufspreis * (1 + this.percentages[i] / 100);
    },
    changeAdjustedValue() {
      var multiplier = 1;
      if (this.cert2) multiplier += 0.25;
      if (this.cert3) multiplier += 0.35;
      multiplier += this.percentages[this.percentage_selected] / 100;

      //runden damit keine Kommazahlen entstehen
      this.salesValue = Math.round(this.verkaufspreis * multiplier);
      // console.log(this.verkaufspreis)
    },
    sellerSubmit() {
      this.$http
        .post("/sellerSubmit", {
          token: this.token,
          welches: this.whichVerkaufId,
          price: this.salesValue,
        })
        .then((res) => {
          // this.setMessage(res.data.msg)
          this.$emit("setMessage", res.data.msg);
          if (res.status === 200 && res.data.type == "success") {
            //   this.sellingList=res.data.sellingList
            //   this.setMessage('submitted new price to sell')
            this.$emit("setMessage", "submitted new price to sell");
            this.salesValue = 0;
            this.whichVerkauf = "";
            this.whichVerkaufId = "";
            this.verkaufspreis = 0;
            this.percentage_selected = 7;
            this.cert2 = false;
            this.cert3 = false;
          }
        });
    },

    //FILTERS
    numberFilter(n) {
      return parseInt(n).toLocaleString("de-DE");
    },
  },
  created() {
    // console.log(this.sellingList);
    // console.log(this.gamePhase);
    this.calcTurnover();
    this.calcGamePhase(this.gamePhase);
  },
};
</script>

<style scoped>
.turnover {
  font-size: 45px;
}

.top1 {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-around;
  margin-bottom: 10px;
}

.preis {
  font-size: 24px;
  margin: 0px 10px;
  width: 160px;
  text-align: center;
}

#middle {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  height: 125px;
  justify-content: space-between;
}

.percentSelect {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  background: white;
  color: #214a7d;
  border-radius: 15px;
  padding: 10px 0;
}

.percentSelect>div {
  flex: 1 1 65px;
  height: 30px;
  text-align: center;
  margin: 6px 0px;
}

#top {
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
}

#SellingListGM {
  width: 37%;
}

.middleText {
  font-size: 20px;
}

.smallerText {
  font-size: 15px;
}

.submit {
  height: 42px;
  border: 3px solid #ffffff;
  background: #214a7c;
  color: #ffffff;
  width: 100%;
  margin-top: 10px;
  font-size: 19px;
}

.submit:hover {
  border: 3px solid #214a7c;
  background: #ffffff;
  color: #214a7c;
}

.flex {
  display: flex;
}

.blue:before {
  border: 2px solid #fff;
  content: "";
  display: block;
  position: absolute;
  top: 2px;
  left: 2px;
  right: 2px;
  bottom: 2px;
  border-radius: 20px;
  pointer-events: none;
}

.blue {
  background-color: #214a7c;
  position: relative;
  border-radius: 20px;
  color: white;
  padding: 1em;
  margin: 1em 0em 1em 0em;
}

.check {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-top: 10px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.check input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkmark {
  position: absolute;
  left: 0;
  top: 0px;
  height: 25px;
  width: 25px;
  background-color: white;
}

.check:hover input~.checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.check input:checked~.checkmark {
  background-color: limegreen;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.check input:checked~.checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.check .checkmark:after {
  left: 8px;
  top: 3px;
  width: 6px;
  height: 13px;
  border: solid white;
  border-width: 0 4px 4px 0;
  transform: rotate(45deg);
}

#sellingPrice {
  margin: 30px 0;
}

.longerInput {
  width: 160px !important;
}

.sellerInput {
  color: #1860b9;
  width: 36px;
  padding: 5px;
  border: 0px;
  font-size: 19px;
  margin-top: -10px;
  margin-bottom: 5px;
}
</style>
